import { Outlet } from 'react-router-dom';
import { App as AntApp } from 'antd';
import { ThemeProvider } from './contexts/ThemeContext';
import { NotificationProvider } from './contexts/NotificationContext';
import { AuthProvider } from './contexts/AuthContext';
import { AppDataProvider } from './contexts/AppDataContext';
import { DashboardProvider } from './contexts/DashboardContext';
import { PlanningProvider } from './contexts/PlanningContext';
import LegacyURLRedirect from './components/common/LegacyURLRedirect';

/** App-wide providers wrapping all routes (inside RouterProvider). */
export default function RootProviders() {
  return (
    <ThemeProvider>
      <AntApp>
        <NotificationProvider>
          <AuthProvider>
            <AppDataProvider>
              <DashboardProvider>
                <PlanningProvider>
                  <LegacyURLRedirect />
                  <Outlet />
                </PlanningProvider>
              </DashboardProvider>
            </AppDataProvider>
          </AuthProvider>
        </NotificationProvider>
      </AntApp>
    </ThemeProvider>
  );
}
